import IntegrationService from '@/services/IntegrationService';

let intercomActivated = false;

/**
 * The default launcher shows on every viewport; `App.vue` pads the content so
 * the last row of actions clears it. Fixed bottom sheets cannot be padded out
 * of its way, so they hide it only while open. Holds are counted so a sheet
 * closing under another open one does not bring the launcher back early.
 */
let launcherHolds = 0;

const setIntercomLauncherHidden = (hidden) => {
	if (typeof window.Intercom === 'function') {
		window.Intercom('update', { hide_default_launcher: hidden });
	}
};

const hideIntercomLauncher = () => {
	launcherHolds += 1;
	if (launcherHolds === 1) setIntercomLauncherHidden(true);
};

const showIntercomLauncher = () => {
	if (!launcherHolds) return;
	launcherHolds -= 1;
	if (!launcherHolds) setIntercomLauncherHidden(false);
};

const activateIntercom = async (userObject) => {
	// Prevent multiple activations
	if (intercomActivated) {
		return;
	}
	
	const isCastrUser = userObject._id && userObject.email && userObject.name;
	if (window._learnq && isCastrUser) {
		window._learnq.push(['identify', {
			'$email': userObject.email
		}]);
	}

	if (window.Autopilot && isCastrUser) {
		window.Autopilot.run("associate", {
			Email: userObject.email,
			FirstName: userObject.name,
			custom: {
				"string--Logged--In": "true"
			}
		});
	}

	if (window.Intercom && isCastrUser) {
		const identityObject = {
			name: userObject.name,
			email: userObject.email,
			user_id: userObject._id,
			created_at: Math.round(new Date(userObject.joinDate || new Date()).getTime() / 1000)
		};

		if(userObject.cmsEntityId && userObject.cmsEntityId > 139398) {
			// use cmdId as user id for intercom 
			identityObject.user_id = userObject.cmsEntityId;
		}
		if (userObject.parentAccount && identityObject.email.includes('castr.io')) {
			identityObject.unsubscribed_from_emails = true
			console.log('identityObject', JSON.stringify({ userObject, identityObject }));
		}

		const token = await IntegrationService.getIntercomJwt(identityObject.user_id);
		const intercomSettings = {
			...identityObject,
			app_id: process.env.VUE_APP_INTERCOM_APP_ID,
			intercom_user_jwt: token,
			session_duration: 86400000,
			...(launcherHolds ? { hide_default_launcher: true } : {}),
		};
		const result = window.Intercom('boot', intercomSettings);
		console.log('Intercom boot result:', result);
		intercomActivated = true; // Mark as activated
	}

	if (window.delighted && isCastrUser) {
		try {
			const sub = (userObject?.subscriptions ?? []).find((sub) => sub.category && sub.category.includes('live'));
			const opt = {
				email: userObject.email,
				name: userObject.name,
				signed_up: userObject.joinDate,
			}
			if (sub) {
				opt.properties = {
					plan: sub.package?.name ?? 'n/a',
					purchase_date: sub.cstart
				}
				if (!(sub.package?.name ?? '').toLowerCase().includes('trial')) {
					delighted.survey(opt)
				}
			}

		} catch(err) {
			console.error('delighted lib init failed')
		}
	}
	
};

const activateSentry = () => {
	if (window.Sentry) {
		Sentry.init({ dsn: process.env.VUE_APP_SENTRY_DSN });
	}
};

export {
	activateIntercom,
	activateSentry,
	hideIntercomLauncher,
	showIntercomLauncher
};
